import React from 'react'
import { useState } from "react";
import { Box, Button, Typography } from '@mui/material'
import { Tabs } from "../../components";
import Card from "../Card/Card";
import PassBill from './PassBill';
import PayRecord from './PayRecord';
import phonePayment from '../../assets/phonePayment.svg'
import { useSearchParams } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const BillingStatements = ({
    billingData,
    paymentData,
    userInfoData,
    snackBar,
    setSnackBar,
}) => {
    const [searchParams] = useSearchParams();
    const [tabValue, setTabValue] = useState(searchParams.get("tab") ?? "billing");
    const [loading, setLoading] = useState(false)

    const [tabs, setTabs] = useState([
        {
            key: "billing",
            label: "過去帳單",
        }
        ,
        {
            key: "transaction",
            label: "交易紀錄",
        }
    ]);

    const getPaymentUrlQueryString = () => {
        const params = new URLSearchParams();
        params.append("customerNo", userInfoData?.customerNo ?? '');
        params.append("customerName", userInfoData?.customerName ?? '');
        params.append("email", userInfoData?.emailAddress ?? '');
        params.append("mobile", userInfoData?.mobilePhone ?? '');
        return params.toString();
    }

    return (
        <>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1301 })}
                open={loading}
                invisible
            >
                <CircularProgress style={{'color': '#495057'}} />
            </Backdrop>
            <Box>
                <Box >
                    <Tabs options={tabs} value={tabValue} onClick={(value) => setTabValue(value)} />
                </Box>
                <Box marginTop={"24px"}>
                    <Card fullWidth >
                        {tabValue === "billing" &&
                            <PassBill
                                billingData={billingData}
                                loading={loading}
                                setLoading={setLoading}
                                snackBar={snackBar}
                                setSnackBar={setSnackBar}
                            />
                        }
                        {
                            tabValue === "transaction" &&
                            <PayRecord
                                paymentData={paymentData}
                                loading={loading}
                                setLoading={setLoading}
                                snackBar={snackBar}
                                setSnackBar={setSnackBar}
                            />
                        }
                    </Card>
                </Box>
                <Box marginTop={"24px"}>
                    <Typography textAlign={"left"} fontSize={14} fontWeight={500}>網上一次過繳交服務費</Typography>
                </Box>
                <Box marginTop={"12px"}>
                    <Card fullWidth >
                        <Box width={"100%"} maxWidth={"360px"} margin={"0 auto"} display={"flex"} flexDirection={"column"} gap={"16px"} padding={"20px 0"}>
                            <Box display={"flex"} flexDirection={"row"} >
                                <Box borderRadius={"12px"} bgcolor={'#FFF3F6'} width={38} height={38} display={"flex"} justifyContent={"center"} alignItems={"center"} marginRight={2}>
                                    <img src={phonePayment} style={{ width: '24px', height: '24px' }} />
                                </Box>
                                <Typography margin={"auto 0"} textAlign={"left"} fontSize={14} fontWeight={500}>線上付款</Typography>
                            </Box>
                            <Box display={"flex"}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    style={{margin:"0 auto"}}
                                    onClick={() => window.open(process.env.REACT_APP_SCHSA_WWW_URL + "/tc/payment-form?" + getPaymentUrlQueryString(), "_blank")}
                                >
                                    立即付款
                                </Button>
                            </Box>
                        </Box>
                    </Card>
                </Box>
            </Box>
        </>
    )
}

export default BillingStatements